import { controls, grouped } from "../controls";
const login_histories = {
  label: "Login Histories",
  pageLabel: "Login Histories", starting: true, url: "autogen",
  formActions: { edit: { allow: false }, delete: { allow: false } },
  pageType: "history",
  formTabs:
  {
    allTabs: [
      { label: "General", uid: "general" },
      { label: "Login Roles", uid: "login_roles" }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", label: "User Code" }),
    ...controls.oc({ tab: "general", length: 4, c: "User", placeHolder: "User Code", name: "user_code", fastpath: "users" }),

    ...controls.showData({ tab: "general", displaytype: "capital", data: "user_display" }),
    ...controls.displayText({ tab: "filter", label: "Branch Code" }),
    ...controls.oc({ tab: "general", length: 4, c: "Branch", placeHolder: "Branch Code", name: "branch_code", fastpath: "branches" }),

    ...controls.showData({ tab: "general", displaytype: "capital", data: "branch_display" }),
    ...controls.checkBox({ tab: "filter", default: false, label: "Is Logged In", name: "is_logged_in" }),
    ...controls.checkBox({ tab: "filter", default: false, label: "Is Suspecious", name: "is_suspecious" }),
  ]
  , form: [
    ...controls.checkBox({ tab: "general", label: "Is Logged In", name: "is_logged_in" }),


    ...controls.displayText({ tab: "login_roles", label: "Role", star: false }),
    ...controls.oc({ tab: "login_roles", c: "Role", placeHolder: "Role Code", name: "role_code", isRequired: false, fastpath: "roles", isReadOnly: "edit" }),
    ...controls.showData({ tab: "login_roles", displaytype: "capital", data: "role_display" }),

    ...controls.displayText({ tab: "login_roles", width: "col-sm-12", label: "" }),
    ...controls.displayText({ tab: "login_roles", width: "col-sm-4", label: "" }),
    ...controls.button({
      tab: "login_roles",
      label: "ADD",
      style: { padding: 0 },
      Bcolor: "success",
      onclick: {
        action: "appendToHTMLTable",
        tableNameField: "login_roles",
        requiredField: ["role_code", "role_display", "role_uid",]
      }, width: "col-sm-2"
    }),
    ...controls.button({
      tab: "login_roles",
      label: "CLEAR",
      style: { padding: 0 },
      Bcolor: "warning",
      onclick: {
        action: "clearForm",
        tableNameField: "login_roles",
        requiredField: ["role_code", "role_display", "role_uid",]
      }, width: "col-sm-2"
    }),
    {
      tab: "login_roles",
      inputType: "table",
      tableTitle: "",
      deletable: true,
      editable: true,
      tableHeaders: [
        { label: "Sr", type: "autoinc" },
        { label: "Role Code", field: "role_code" },
        { label: "Role Display", field: "role_display" },
      ],
      widths: {
        parent: "col-sm-12",
        children: "col-sm-12"
      },
      name: "login_roles"
    },
  ]
  , history: {
    perPage: 10,
    reportHeader: "Login Histories",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
      { Header: "User Id", accessor: "LoginHistory-user-user_code", },
      { Header: "Branch Id", accessor: "LoginHistory-branch-branch_display", },
      { Header: "Login Time", accessor: "login_time", type: 'datetime' },
      { Header: "Logout Time", accessor: "logout_time", type: 'datetime' },
      { Header: "Is Logged In", accessor: "is_logged_in", type: 'tick' },
      { Header: "Is Suspecious", accessor: "is_suspecious", type: 'tick' },
      { Header: "Suspecious Note", accessor: "suspecious_note", },
      { Header: "Photo Url", accessor: "photo_url", type: "image" },
    ]
  }
};
export default login_histories;